import React, { useState, useEffect } from 'react';
import './StoryLoadingAnimation.css';

const StoryLoadingAnimation = ({ results }) => {
  const [loadingMessage, setLoadingMessage] = useState('Initializing story generation...');
  
  useEffect(() => {
    const messages = [
      'Crafting your financial narrative...',
      'Analyzing market implications...',
      'Evaluating correlation patterns...',
      'Structuring the narrative...',
      'Adding market context...',
      'Polishing the prose...',
      'Generating social media content...',
      'Researching market trends...',
      'Incorporating expert analysis...',
      'Optimizing for engagement...',
      'Finalizing the story...',
      'Preparing for publication...',
      'Almost complete...'
    ];
    
    let currentIndex = 0;
    const interval = setInterval(() => {
      currentIndex = (currentIndex + 1) % messages.length;
      setLoadingMessage(messages[currentIndex]);
    }, 7000);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className="story-loading-overlay">
      <div className="story-loading-container">
        <div className="story-spinner"></div>
        <div className="story-loading-message">{loadingMessage}</div>
        <div className="story-loading-submessage">
          Please wait while we craft your story...
        </div>
      </div>
    </div>
  );
};

export default StoryLoadingAnimation;